import React, { useEffect, useState } from "react";
import {
  HeaderRow,
  Link,
  MaterialTable,
  MaterialTableContainer,
  fetchDataCollection,
  generateFile,
} from "./util";
import { Ptag } from "../../../components/fonts";
import { colors } from "../../../theme";
import EmptyTable from "../../../components/EmptyTable";
import { formatDateReverse, getFileNameFromUrl } from "../../../utils/utils";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { OverlayLoader } from "../../../components";

const HEADERS = [
  "Batch Number",
  "Total Employees",
  "Upload Date",
  "File Uploaded",
  "Cut-Off Date",
  "Employee Confirmations",
  "",
];

function DataCollection() {
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState();
  const [emptyData, setEmptyData] = useState(false);

  useEffect(() => {
    (async function() {
      fetchDataCollection(setLoading, setEmptyData, setTableData);
    })();
  }, []);

  return loading ? <OverlayLoader /> : (
    <section
      style={{
        padding: "4rem",
        backgroundColor: "white",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
        }}
      >
        <Ptag
          fontSize="24px"
          fontWeight="700"
          style={{ paddingBottom: "36px" }}
        >
          Data Collection History
        </Ptag>
        {emptyData ? (
          <EmptyTable />
        ) : (
          <TableContainer sx={MaterialTableContainer}>
            <Table aria-balel="simple table" sx={MaterialTable}>
              <TableHead>
                <TableRow>
                  {HEADERS.map((header, index) => (
                    <TableCell style={{
                        width: header === "Employee Confirmations" ? "182px" : "150px"
                    }}
                      key={index}
                      variant="head"
                      align="center"
                      sx={HeaderRow}
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {tableData &&
                  typeof tableData === "object" &&
                  tableData.map((value, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell align="center" component="th" scope="row">
                        <Ptag
                          style={{ display: "inline" }}
                        >{`Batch ${value["Batch Number"]}`}</Ptag>
                      </TableCell>
                      <TableCell align="center" component="th" scope="row">
                        <Ptag style={{ display: "inline" }}>
                          {value["Total Employees Count"]}
                        </Ptag>
                      </TableCell>
                      <TableCell align="center">
                        <Ptag style={{ display: "inline" }}>
                          {value["File Upload Date"] &&
                            formatDateReverse(value["File Upload Date"])}
                        </Ptag>
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        <Link href={value["File Uploaded"]}>
                          {getFileNameFromUrl(value["File Uploaded"])}
                        </Link>
                      </TableCell>
                      <TableCell align="center">
                        <Ptag style={{ display: "inline" }}>
                          {value["File Upload Date"] &&
                            formatDateReverse(value["Cut-Off Date"])}
                        </Ptag>
                      </TableCell>
                      <TableCell align="center" component="th" scope="row">
                        <Ptag style={{ display: "inline" }}>
                          {value["Confirmed Employees Count"]}
                        </Ptag>
                      </TableCell>
                      <TableCell align="center">
                        <Ptag
                          style={{ display: "inline", cursor: "pointer" }}
                          color="#4A90E2"
                          onClick={() => generateFile(value.async_task_id)}
                        >
                          Download File
                        </Ptag>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </div>
    </section>
  );
}

export default DataCollection;
